export enum PermissionKey {
  companyOptionManagement = 'COMPANY_OPTION_MANAGEMENT',
  companySettingLoginPass = 'COMPANY_SETTING_LOGIN_PASS',
  companyDeleteLiveRole = 'COMPANY_DELETE_LIVE_ROLE',
  companyExportData = 'COMPANY_EXPORT_DATA',
  accountDeleteLiveRole = 'ACCOUNT_DELETE_LIVE_ROLE',
  accountExportData = 'ACCOUNT_EXPORT_DATA',
  helpPostEdit = 'HELP_POST_EDIT',
  useTermUpdateEdit = 'USE_TERM_UPDATE_EDIT',
  adminRoleEditCcjAdmin = 'ADMIN_ROLE_EDIT_CCJ_ADMIN',
  adminRoleModifyLiveConsoleRole = 'ADMIN_ROLE_MODIFY_LIVE_CONSOLE_ROLE',
  systemManagementExecution = 'SYSTEM_MANAGEMENT_EXECUTION',
}
